module.exports = __webpack_public_path__ + "static/img/fudan.945a3c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/fudan.jpg
// module id = IDIi
// module chunks = 1